import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-animation"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "competition-details"
}

import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import CompetitionStandingsFilter, {
  ActiveFilterOpts,
} from '@/components/widgets/public/CompetitionStandingsFilter.vue'
import CompetitionStandingsIndividual from '@/components/widgets/public/CompetitionStandingsIndividual.vue'
import CompetitionStandingsTeam from '@/components/widgets/public/CompetitionStandingsTeam.vue'
import { useCompetitionStore } from '@/store/public/competition'
import {
  CompetitionIndividualStandingsSlip,
  CompetitionTeamStandingsSlip,
} from '@/store/public/competition.types'
import { getErrorMessage } from '@/utils/error-handling'
import { formatDate, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompetitionView',
  setup(__props) {

const competition = useCompetitionStore()

const errorMessage = ref<string | null>()
const isLoading = ref<boolean>(false)

const activeFilterDefaultIndex = computed<number>((): number =>
  Number((competition.details?.ruleCount ?? 0) > 0),
)

const activeFilter = ref<ActiveFilterOpts>({
  category: 'individual',
  index: 0,
})

onMounted(async (): Promise<void> => {
  isLoading.value = true

  const competitionId = useRoute().params.id as string

  try {
    await competition.fetch(competitionId)
    await competition.fetchIndividualStandings(competitionId)
    await competition.fetchTeamStandings(competitionId)
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(
      `Failed fetching results for competition ID ${competitionId}: ${message}`,
    )
    errorMessage.value = message
  }

  activeFilter.value.index = activeFilterDefaultIndex.value

  isLoading.value = false
})

const filterByRuleOptions = computed<string[]>((): string[] =>
  (competition.standings.individual ?? []).map((slip) => slip.label),
)

const filterByTeamSizeOptions = computed<string[]>((): string[] =>
  (competition.standings.team ?? []).map((slip) => slip.label),
)

const selectedIndividualStandingsSlip =
  computed<CompetitionIndividualStandingsSlip | null>(
    (): CompetitionIndividualStandingsSlip | null =>
      competition.standings.individual?.at(activeFilter.value.index) ?? null,
  )

const selectedTeamStandingsSlip = computed<CompetitionTeamStandingsSlip | null>(
  (): CompetitionTeamStandingsSlip | null =>
    competition.standings.team?.at(activeFilter.value.index) ?? null,
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BusyIndicator)
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 1,
            message: errorMessage.value,
            "is-danger": ""
          }, null, 8, ["message"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("h1", null, _toDisplayString(_unref(competition).name), 1),
            (_unref(competition).dates)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_unref(formatDate)(_unref(competition).dates.start)) + " ", 1),
                  (
            _unref(competition).dates.start.getTime() !==
            _unref(competition).dates.end.getTime()
          )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" – " + _toDisplayString(_unref(formatDate)(_unref(competition).dates.end)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(competition).details)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('competition-standings.association')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(formatValue)(_unref(competition).details?.associationName)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('competition-standings.bowling-alleys')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(formatValue)(
              (_unref(competition).details?.bowlingAlleyNames ?? []).join(', '),
            )), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('competition-standings.supervisor')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(formatValue)(_unref(competition).details?.supervisor)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('competition-standings.last-updated')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(formatDate)(_unref(competition).dates?.update)), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(CompetitionStandingsFilter, {
              "active-filter": activeFilter.value,
              "active-filter-default-index": activeFilterDefaultIndex.value,
              rules: filterByRuleOptions.value,
              "team-sizes": filterByTeamSizeOptions.value,
              onSelect: _cache[0] || (_cache[0] = (value) => (activeFilter.value = value))
            }, null, 8, ["active-filter", "active-filter-default-index", "rules", "team-sizes"]),
            (activeFilter.value.category === 'individual')
              ? (_openBlock(), _createBlock(CompetitionStandingsIndividual, {
                  key: 2,
                  slip: selectedIndividualStandingsSlip.value
                }, null, 8, ["slip"]))
              : _createCommentVNode("", true),
            (activeFilter.value.category === 'teams')
              ? (_openBlock(), _createBlock(CompetitionStandingsTeam, {
                  key: 3,
                  slip: selectedTeamStandingsSlip.value
                }, null, 8, ["slip"]))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}
}

})